import React from 'react';
import {
  gridPageCountSelector,
  gridPageSelector,
  useGridApiContext,
  useGridSelector,
} from '@mui/x-data-grid';

export const GeniusPaginationButtons = ({
  page,
  totalPages,
  onPageChange,
  compact = false,
}) => {
  if (totalPages <= 1) {
    return null;
  }

  const getPages = () => {
    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pages = [];
    const startPage = Math.max(1, Math.min(page - 1, totalPages - 4));
    const endPage = Math.min(totalPages, startPage + 4);

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (!pages.includes(1)) {
      pages.unshift(1);
    }

    if (pages[pages.length - 1] < totalPages) {
      pages.push('ellipsis', totalPages);
    }

    return pages;
  };

  const buttonClass =
    'min-w-[34px] h-[34px] px-3 rounded-md border border-black text-white bg-black text-sm flex items-center justify-center disabled:opacity-50 disabled:cursor-not-allowed';

  return (
    <div className="flex items-center justify-center gap-2 print:hidden">
      <button
        type="button"
        className={`${buttonClass} ${compact ? 'min-w-[34px] px-2' : ''}`}
        disabled={page === 1}
        onClick={() => onPageChange(page - 1)}
      >
        {compact ? '«' : <>&laquo; Previous</>}
      </button>
      {getPages().map((item, index) =>
        item === 'ellipsis' ? (
          <span
            key={`ellipsis-${index}`}
            className="h-[34px] px-1 flex items-center text-[#212529]"
          >
            ...
          </span>
        ) : (
          <button
            type="button"
            key={item}
            className={`${buttonClass} ${
              item === page ? 'ring-2 ring-[#9ca3af] ring-offset-1' : ''
            }`}
            onClick={() => onPageChange(item)}
          >
            {item}
          </button>
        )
      )}
      <button
        type="button"
        className={`${buttonClass} ${compact ? 'min-w-[34px] px-2' : ''}`}
        disabled={page === totalPages}
        onClick={() => onPageChange(page + 1)}
      >
        {compact ? '»' : <>Next &raquo;</>}
      </button>
    </div>
  );
};

const GeniusDataGridPagination = () => {
  const apiRef = useGridApiContext();
  const page = useGridSelector(apiRef, gridPageSelector);
  const pageCount = useGridSelector(apiRef, gridPageCountSelector);

  return (
    <GeniusPaginationButtons
      page={page + 1}
      totalPages={pageCount}
      onPageChange={(nextPage) => apiRef.current.setPage(nextPage - 1)}
    />
  );
};

export default GeniusDataGridPagination;
